module.exports = __webpack_public_path__ + "img/step4-c.553cad8f.png";